<template>
  <ul class="icon-row">
    <div class="icon-row__inner">
      <icon-row-item
        v-for="icon in icons"
        :id="icon.id"
        :image="icon.illustration"
        :iconLabel="icon.headline"
        :key="icon.id"
        @buttonClick="buttonClicked"
      />
    </div>
  </ul>
</template>

<script>
import IconRowItem from './IconRowItem.vue'

export default {
  props: {
    icons: {
      type: Array,
      required: true
    }
  },
  components: {
    IconRowItem
  },
  methods: {
    buttonClicked (id) {
      this.$emit('buttonClick', id)
    }
  }
}
</script>

<style lang="scss">
.icon-row {
  background-color: var(--color-bg);
  border-top: 1px solid rgba(var(--color-text), 0.6);
  bottom: 0;
  box-shadow: var(--shadow-2);
  left: 0;
  margin: 0;
  padding: 0 var(--site-padding);
  position: fixed;
  height: 3rem;
  width: 100vw;
}

.icon-row__inner {
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: space-around;
  margin: 0 auto;
  max-width: 34rem;
  text-align: center;

  @supports (display: grid) {
    display: grid;
    grid-template-columns: repeat(4, 3rem);
    grid-column-gap: 1rem;
  }
}
</style>
